export default __webpack_public_path__ + "static/media/icon-fifth-empty.8cfbe653.svg";